import menuBarDirective from './menuBar.directive.js';
import menuDirective from './menu.directive.js';
import hideNotificationDirective from './hide-notification.directive.js';

angular.module('app.menu', ['app.services'])
  .directive('menuBar', menuBarDirective)
  .directive('menu', menuDirective)
  .directive('hideNoty', hideNotificationDirective);



/** WEBPACK FOOTER **
 ** ./src/app/components/menu/menu.module.js
 **/